import React from "react";
import { Box } from "@mui/material";
import Header from "./Header";
import Footer from "./Footer";

export default function PageShell({ children }) {
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Header />
      <Box component="main" sx={{ flex: 1, pt: "72px" }}>
        {children}
      </Box>
      <Footer />
    </Box>
  );
}